/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useCallback, useEffect } from "react";
import "../css/integration.css";
import callApi from "../utils/apiCaller";
import Swal from "sweetalert2";
import uuid from "uuid-random";
import {
	DeleteMajor,
	DomainNewMajor,
	DuplicateMinor,
	ExchangeMajor,
	ExistingInventoryMajor,
} from "@shopify/polaris-icons";
import moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
	Button,
	Card,
	Banner,
	Icon,
	Modal,
	Badge,
	Link,
	TextContainer,
	TextField,
	Checkbox,
	Heading,
	Toast,
	Frame,
	Select,
} from "@shopify/polaris";
import { Row, Table, Col } from "reactstrap";
import config from "../config/config";
import {
	actFetchDataSettings,
	actFetchListStore,
	actFetchShowLoadingPage,
} from "../actions/index";

import { useDispatch, useSelector } from "react-redux";
import Instructions from "./Instructions";
import Tabs from "./Settings/Tabs";
import PaypalSettings from "./Settings/PaypalSettings";
import Mollie from "./Settings/Mollie";
import Account from "./Account";
import Stripe from "./Settings/Stripe";
import { useHistory } from "react-router-dom";
import Key from "./Settings/Key";
import Integration from "./Integration";
import General from "./Settings/General";
import BannerWoo from "./Dashboard/BannerWoo";
import BannerDispute from "./dispute/BannerDispute";
import Analysis from "./dispute/Analysis";
import DisputeTable from "./dispute/DisputeTable";

const Dispute = () => {
	const dispatch = useDispatch();
	const dataSettings = useSelector((state) => state.dataSettings);
	const [timeSelected, setTimeSelected] = useState("30_days");
	const optionsTimeRange = [
		{ label: "Today", value: "today" },
		{ label: "Yesterday", value: "yesterday" },
		{ label: "Last 7 days", value: "7_days" },
		{ label: "Last 30 days", value: "30_days" },
		{ label: "This month", value: "this_month" },
		{ label: "Last month", value: "last_month" },
	];
	return (
		<div style={{ marginTop: "20px" }} className="dispute-page">
			{config.platform !== "WOO_COMMERCE" ? (
				<div>
					<BannerDispute />
					<Row className=" mt-3 mb-2">
						<Col>
							<a
								href="https://docs.synctrack.io/feature-guides/how-to-get-dispute-administration"
								target="_blank"
							>
								View Dispute management instruction
							</a>
						</Col>
						<Col
							className="float-right mr-5"
							style={{
								display: "flex",
								justifyContent: "flex-end",
							}}
						>
							<div style={{ width: "25%" }}>
								<Select
									label="Date Range"
									labelInline
									options={optionsTimeRange}
									onChange={setTimeSelected}
									value={timeSelected}
								/>
							</div>
						</Col>
					</Row>
					<Analysis timeSelected={timeSelected} />
					<Row className="mt-3">
						<Col xs="12" sm="12" md="12" lg="12">
							<DisputeTable timeSelected={timeSelected} />
						</Col>
					</Row>
				</div>
			) : (
				<div className="mt-3">
					<Banner
						title="This function is currently available on the application for Shopify stores and will launch on Woocommerce, Bigcommerce,... in the near future."
						status="info"
					></Banner>
				</div>
			)}
		</div>
	);
};

export default Dispute;
